// extracted by mini-css-extract-plugin
export var btn = "rightSection-module--btn--yP3-7";
export var container = "rightSection-module--container--XxOUo";
export var countdown = "rightSection-module--countdown--rsWyJ";
export var countdownBlock = "rightSection-module--countdownBlock--I5Tl8";
export var countdown_container = "rightSection-module--countdown_container--Fd+9G";
export var halvaTen = "rightSection-module--halvaTen--uIbvI";
export var halvaTenContainer = "rightSection-module--halvaTenContainer---Bnt2";
export var hint = "rightSection-module--hint--sx1Kt";
export var hintNY = "rightSection-module--hintNY--gKcL5";
export var pointer = "rightSection-module--pointer--Rudx8";
export var pravdaCoffee = "rightSection-module--pravdaCoffee--DOadK";
export var zadolzhennostej = "rightSection-module--zadolzhennostej--Ki0jZ";